import { useState } from 'react'

const useCsvReader = () => {
  const [data, setData] = useState<string[] | null>(null)

  const onSelectFile = async (file: File) => {
    const reader = new FileReader()
    reader.readAsText(file)
    reader.onload = () => {
      if (typeof reader.result !== 'string') return
      // Windowsの場合、改行コードが \r\n なので \n に変換してから分割
      const rows = reader.result.replace(/\r?\n/g, '\n').split('\n')
      setData([...rows])
    }
  }

  return {
    data,
    setData,
    onSelectFile,
  }
}

export default useCsvReader
